// ============================================================
// SkyPlus Intelligence Service
// app/components/skyplus/intelligence/intelligence.service.ts
// ============================================================

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '@alfresco/adf-core';
import { Observable } from 'rxjs';
import { AppConfigService } from '@alfresco/adf-core';
export interface Citation {
  nodeId:   string;
  name:     string;
  type:     'claim' | 'policy' | 'document' | string;
  snippet?: string;
}

export interface SuggestedFollowup {
  label:    string;
  question: string;
}

export interface IntelligenceResponse {
  answer:     string;
  citations:  Citation[];
  suggested:  SuggestedFollowup[];
  tier?:      'tier1' | 'tier2' | 'fallback';
  tone?:      'info' | 'warning' | 'success';
}

@Injectable({ providedIn: 'root' })
export class IntelligenceService {
  private apiUrl: string;
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private appConfig: AppConfigService
  ) {
    this.apiUrl = this.appConfig.get<string>('skyplus.apiUrl', '/bpm/api');
  }

  ask(question: string, contextNodeId?: string): Observable<IntelligenceResponse> {
    const baseUrl = this.apiUrl || 'http://localhost:9090/api';

    // Pull the JWT from ADF's AuthenticationService - same pattern your
    // flip viewer and document library use.
    const token = this.authService.getToken();
    const headers = new HttpHeaders(
      token ? { 'Authorization': `Bearer ${token}` } : {}
    );

    return this.http.post<IntelligenceResponse>(
      `${baseUrl}/intelligence/ask`,
      { question, contextNodeId: contextNodeId || null },
      { headers }
    );
  }
}